import { encryptedKeyByRsaKeyValidator } from './encrypted-key-by-rsa-key';
import { signedEntityByRsaKeyValidator } from './singed-entity-by-rsa-key';
import { stringValidator } from './string';
export const signedEncryptedKeyByRsaKeyValidator = stringValidator({
    requiredError: 'internal.required',
}).superRefine((value, ctx) => {
    const [cipherText, signature, ...rest] = value.split(':');
    if (rest.length) {
        ctx.addIssue({
            code: 'custom',
            message: 'internal.malformed',
            fatal: true,
        });
    }
    const cipherTextParseResult = encryptedKeyByRsaKeyValidator.safeParse(cipherText);
    if (!cipherTextParseResult.success) {
        cipherTextParseResult.error.issues.forEach((issue) => {
            ctx.addIssue(issue);
        });
    }
    const signatureParseResult = signedEntityByRsaKeyValidator.safeParse(signature);
    if (!signatureParseResult.success) {
        signatureParseResult.error.issues.forEach((issue) => {
            ctx.addIssue(issue);
        });
    }
});
